const ORIGIN_OPTIONS = [
  { id: 0, name: 'Não conformidade', value: 'nc' },
  { id: 1, name: 'Auditoria', value: 'audit' },
  { id: 2, name: 'KPI fora da meta', value: 'kpi_out_of_goal' },
  { id: 3, name: 'Análise Crítica', value: 'critical_analysis' },
  { id: 4, name: 'Sugestão interna', value: 'internal_suggestion' },
  { id: 5, name: 'Requisito legal', value: 'legal_requirement' },
  { id: 6, name: 'Outro', value: 'other' },
]

const NON_CONFORMITY_ORIGIN = 0
const AUDIT_ORIGIN = 1
const KPI_OUT_OF_GOAL_ORIGIN = 2
const CRITICAL_ANALYSIS_ORIGIN = 3
const INTERNAL_SUGGESTION_ORIGIN = 4
const LEGAL_REQUIREMENT_ORIGIN = 5
const OTHER_ORIGIN = 6

const NON_CONFORMITY_ORIGIN_LABEL = 'não conformidade'
const AUDIT_ORIGIN_LABEL = 'auditoria'
const KPI_OUT_OF_GOAL_ORIGIN_LABEL = 'kpi fora da meta'
const CRITICAL_ANALYSIS_ORIGIN_LABEL = 'análise crítica'
const INTERNAL_SUGGESTION_ORIGIN_LABEL = 'sugestão interna'
const LEGAL_REQUIREMENT_ORIGIN_LABEL = 'requisito legal'
const OTHER_ORIGIN_LABEL = 'outro'

const ORIGINS = {
  [NON_CONFORMITY_ORIGIN]: 'NÃO CONFORMIDADE',
  [AUDIT_ORIGIN]: 'AUDITORIA',
  [KPI_OUT_OF_GOAL_ORIGIN]: 'KPI FORA DA META',
  [CRITICAL_ANALYSIS_ORIGIN]: 'ANÁLISE CRÍTICA',
  [INTERNAL_SUGGESTION_ORIGIN]: 'SUGESTÃO INTERNA',
  [LEGAL_REQUIREMENT_ORIGIN]: 'REQUISITO LEGAL',
  [OTHER_ORIGIN]: 'OUTRO',
}

const IMPROVEMENT_TYPE_OPTIONS = [
  { id: 0, name: 'Processo', value: 'process' },
  { id: 1, name: 'Documentação', value: 'documentation' },
  { id: 2, name: 'Tecnologia', value: 'technology' },
  { id: 3, name: 'Capacitação', value: 'training' },
  { id: 4, name: 'Governança', value: 'governance' },
]

const PROCESS_IMPROVEMENT_TYPE = 0
const DOCUMENTATION_IMPROVEMENT_TYPE = 1
const TECHNOLOGY_IMPROVEMENT_TYPE = 2
const TRAINING_IMPROVEMENT_TYPE = 3
const GOVERNANCE_IMPROVEMENT_TYPE = 4

const PROCESS_IMPROVEMENT_TYPE_LABEL = 'processo'
const DOCUMENTATION_IMPROVEMENT_TYPE_LABEL = 'documentação'
const TECHNOLOGY_IMPROVEMENT_TYPE_LABEL = 'tecnologia'
const TRAINING_IMPROVEMENT_TYPE_LABEL = 'capacitação'
const GOVERNANCE_IMPROVEMENT_TYPE_LABEL = 'governança'

const IMPROVEMENT_TYPES = {
  [PROCESS_IMPROVEMENT_TYPE]: 'PROCESSO',
  [DOCUMENTATION_IMPROVEMENT_TYPE]: 'DOCUMENTAÇÃO',
  [TECHNOLOGY_IMPROVEMENT_TYPE]: 'TECNOLOGIA',
  [TRAINING_IMPROVEMENT_TYPE]: 'CAPACITAÇÃO',
  [GOVERNANCE_IMPROVEMENT_TYPE]: 'GOVERNANÇA',
}

const IN_PROGRESS_STATUS = 0
const OVERDUE_STATUS = 1
const FINALIZED_STATUS = 2

const IN_PROGRESS_STATUS_LABEL = 'in_progress'
const OVERDUE_STATUS_LABEL = 'overdue'
const FINALIZED_STATUS_LABEL = 'finalized'

const STATUSES = {
  [IN_PROGRESS_STATUS_LABEL]: 'EM PROGRESSO',
  [OVERDUE_STATUS_LABEL]: 'ATRASADO',
  [FINALIZED_STATUS_LABEL]: 'FINALIZADO',
}

const STATUS_OPTIONS = [
  { id: 0, name: 'Em Progresso', value: 'in_progress' },
  { id: 1, name: 'Atrasado', value: 'overdue' },
  { id: 2, name: 'Finalizado', value: 'finalized' },
]

export default {
  AUDIT_ORIGIN_LABEL,
  AUDIT_ORIGIN,
  CRITICAL_ANALYSIS_ORIGIN_LABEL,
  CRITICAL_ANALYSIS_ORIGIN,
  DOCUMENTATION_IMPROVEMENT_TYPE_LABEL,
  DOCUMENTATION_IMPROVEMENT_TYPE,
  FINALIZED_STATUS_LABEL,
  FINALIZED_STATUS,
  GOVERNANCE_IMPROVEMENT_TYPE_LABEL,
  GOVERNANCE_IMPROVEMENT_TYPE,
  IMPROVEMENT_TYPE_OPTIONS,
  IMPROVEMENT_TYPES,
  IN_PROGRESS_STATUS_LABEL,
  IN_PROGRESS_STATUS,
  INTERNAL_SUGGESTION_ORIGIN_LABEL,
  INTERNAL_SUGGESTION_ORIGIN,
  KPI_OUT_OF_GOAL_ORIGIN_LABEL,
  KPI_OUT_OF_GOAL_ORIGIN,
  LEGAL_REQUIREMENT_ORIGIN_LABEL,
  LEGAL_REQUIREMENT_ORIGIN,
  NON_CONFORMITY_ORIGIN_LABEL,
  NON_CONFORMITY_ORIGIN,
  ORIGIN_OPTIONS,
  ORIGINS,
  OTHER_ORIGIN_LABEL,
  OTHER_ORIGIN,
  OVERDUE_STATUS_LABEL,
  OVERDUE_STATUS,
  PROCESS_IMPROVEMENT_TYPE_LABEL,
  PROCESS_IMPROVEMENT_TYPE,
  STATUS_OPTIONS,
  STATUSES,
  TECHNOLOGY_IMPROVEMENT_TYPE_LABEL,
  TECHNOLOGY_IMPROVEMENT_TYPE,
  TRAINING_IMPROVEMENT_TYPE_LABEL,
  TRAINING_IMPROVEMENT_TYPE,
}
